export default __webpack_public_path__ + "static/media/Imersao_ambiente_profissional_aiamis.6ca17dc2.png";